import { Component, OnInit } from '@angular/core';
import { GroupList } from 'src/app/modules/notification/models/notification.model';
import { NotificationService} from '../../services/notification.service'
@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {

  groupList:GroupList
  groupDetail:any
  displayedColumns=[
    'number',
    'name',
    'action',
  ]

  pageSizeOptions:number[] = [
    20,
    50,
    100,
    200,
    500
  ];
  pageSize:number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;

  constructor(
    private notificationService:NotificationService,
  ) { }

  ngOnInit(): void {
    this.getNotificationGroupsList();
  }

  getNotificationGroupsList(reset:boolean=false){
    if(reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset};
    this.notificationService.getNotificationGroupsList(filters).subscribe(res=>{
      this.groupList=res;
    })
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getNotificationGroupsList()
  }

}
